import { useState } from 'react';

export default function PasswordField({
  id,
  label,
  value,
  onChange,
  placeholder,
  autoComplete = 'new-password',
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="security-form-field">
      {label && (
        <label className="security-form-field__label" htmlFor={id}>
          {label}
        </label>
      )}
      <div className="security-form-field__control-wrap">
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          className="security-form-field__control"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
        />
        <button
          type="button"
          className="security-form-field__toggle"
          aria-label={visible ? '隱藏密碼' : '顯示密碼'}
          onClick={() => setVisible((prev) => !prev)}
        >
          {visible ? '🙈' : '👁'}
        </button>
      </div>
    </div>
  );
}
